// mixin 객체 생성
var sideMixin = {
    mounted() {
        this.$nextTick(function () {
            // console.log(this.$refs.container);
            this.$refs.container.addEventListener('click', () => {
                this.clearpopup();
            }, false);
        });

    },
    methods: {
        clearpopup: function () {
            this.$store.dispatch("offGnb");
        },

    }
}
export default sideMixin;